import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../firebase'; 
import { convertBlobToBase64, formatDateForContract } from './shared';
import { generateOfficialRules } from './officialRules';
import { generateExecutionChecklist } from './executionChecklist';
import { generateWinnerAffidavit } from './winnerAffidavit';

export const generateContractsFromTemplates = async (orderDetails, dealershipInfo, prizes, orderId) => {
  try {
    let logoData = null;
    try {
      const srmgClientDoc = await getDoc(doc(db, 'clients', 'g3RxAQ8jqJkeLecB7aUR'));
      if (srmgClientDoc.exists()) {
        const logoUrl = srmgClientDoc.data().blackLogo;
        if (logoUrl) {
          const response = await fetch(logoUrl);
          const blob = await response.blob();
          logoData = await convertBlobToBase64(blob);
        }
      }
    } catch (e) {
      console.warn('Could not load SRMG logo:', e);
    }


    const jobNumber = orderDetails.jobNumber || 'SRMG-001';
    const contractData = {
      contractNumber: `${jobNumber}-${Date.now().toString().slice(-6)}`,
      dealershipName: dealershipInfo?.name || 'DEALERSHIP NAME',
      startDate: formatDateForContract(orderDetails.drops?.[0]?.startDate),
      endDate: formatDateForContract(orderDetails.drops?.[orderDetails.drops.length - 1]?.endDate),
      totalMailers: parseInt(orderDetails.quantity, 10) || 30000,
      redemptionLocation: `${dealershipInfo?.name || ''} - ${dealershipInfo?.street1 || ''}, ${dealershipInfo?.city || ''}, ${dealershipInfo?.state || ''} ${dealershipInfo?.zip || ''}`.trim(),
      prizes: (prizes || []).filter(p => p.prize).map((prize) => ({
        value: prize.value || '0',
        description: prize.prize === 'Other' ? prize.custom : prize.prize,
        odds: prize.odds || `1:${orderDetails.quantity || 30000}`
      }))
    };


    const results = [];
    results.push(await generateOfficialRules(contractData, logoData));     // base 9
    results.push(await generateExecutionChecklist(contractData, logoData)); // base 11
    results.push(await generateWinnerAffidavit(contractData, logoData));    // base 9

        // --- Attach IRS Form W-9 as-is (downloadable) ---
    try {
      // Placed in /public/forms/Form W-9.pdf
      const w9Res = await fetch('/assets/w9.pdf');
      if (w9Res.ok) {
        const w9Blob = await w9Res.blob();
        results.push({
          name: 'Form_W-9',
          pdf: null,       
          blob: w9Blob
        });
      } else {
        console.warn('W-9 fetch failed with status:', w9Res.status);
      }
    } catch (e) {
      console.warn('Could not attach W-9:', e);
    }

    return results;
  } catch (error) {
    console.error('Error in generateContractsFromTemplates:', error);
    throw error;
  }
};
